import { api } from './index';
import { Methods } from './interfaces';
import { IMovePaymentReq, IMovePaymentRes } from './models/movePayment';
import {
  IGetMovePaymentHistoryReq,
  IGetMovePaymentHistoryRes,
} from './models/getMovePaymentHistory';
import { ExtendedPayment } from '@/types/payment';
import { PaymentPlan } from '@/types/paymentPlan';

const { POST, GET, PUT } = Methods;

interface UpdatePaymentReq {
  id: string;
  seller?: string;
  sellerIds?: string[];
  linkToAmoCrm?: string;
}

const updatePayment = (payload: UpdatePaymentReq) =>
  api<UpdatePaymentReq, void>({
    method: POST,
    route: '/payment/update',
    payload,
  });

/*
  Инициализация платежа
*/
interface InitPaymentReq {
  tel: string;
  receiverId?: string;
  plan: string;
  email: string;
  method: string;
  timezone: string;
}

interface InitPaymentRes {
  url?: string;
  orderID?: string;
}

const initPayment = (payload: InitPaymentReq) =>
  api<InitPaymentReq, InitPaymentRes>({
    method: POST,
    route: '/payment/init',
    payload,
  });

/*
  Перемещение платежа
*/
export const movePayment = (payload: IMovePaymentReq) => {
  return api<IMovePaymentReq, IMovePaymentRes>({
    method: POST,
    route: '/payment/move',
    payload,
  });
};

/*
  Получить историю перемещений платежа
*/
export const getMovePaymentHistory = (payload: IGetMovePaymentHistoryReq) => {
  return api<IGetMovePaymentHistoryReq, IGetMovePaymentHistoryRes[]>({
    method: GET,
    route: '/payment/move',
    payload,
  });
};

/*
  Получить историю перемещений платежа
*/
interface getPaymentPlanReq {
  plan: string;
}

interface getPaymentPlanRes {
  plan: PaymentPlan;
}

const getPaymentPlan = (payload: getPaymentPlanReq) =>
  api<getPaymentPlanReq, getPaymentPlanRes>({
    method: POST,
    route: '/payment/plan',
    payload,
  });

export interface ManualPayment {
  id?: string;
  created: string;
  price: number;
  currency: string;
  email: string;
  status: string;
  lessonCount?: number;
}

const createManualPayment = (payload: ManualPayment) =>
  api<ManualPayment, ExtendedPayment>({
    method: POST,
    route: '/payment/manual',
    payload,
  });

const updateManualPayment = (payload: ManualPayment) =>
  api<ManualPayment, ExtendedPayment>({
    method: PUT,
    route: '/payment/manual',
    payload,
  });

const getReceiptUrl = (id: string) =>
  api<any, any>({
    method: GET,
    route: `/payment/receipt/${id}`,
  });

export const PaymentApi = {
  movePayment,
  getMovePaymentHistory,
  initPayment,
  getPaymentPlan,
  updatePayment,
  createManualPayment,
  updateManualPayment,
  getReceiptUrl,
};
